import { Dispatch } from 'redux';

import * as Actions from '../actions/quickModeStudentAssign';
import AbstractScenario from './AbstractScenario';

export interface IParam {
	freeword: string;
	orgID: string;
}
/**
 * コンテンツ情報取得シナリオファクトリ
 */
export default class QuickModeStudentAssignScenarioFactory {
	/**
	 * コンテンツ情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchCareerList(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<IParam> {
			protected process(param: IParam) {
				const params = {
					accessType: 10,
					freeword: param.freeword,
					orgID: param.orgID,
				};
				return this.read(
					'per_quickmode_SearchCareerListBlockModel',
					params
				).then(data => {
					this.dispatch(
						Actions.setSearchList({
							data: data.careerResults,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
	/**
	 * ログファイルをダウンロード
	 * @param dispatch
	 * @param token
	 */
	public static createFetchLogFileDownload(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process() {
				const params = {
					accessType: 10,
				};
				return this.read(
					'per_quickmode_SearchLogFileBlockModel',
					params
				).then(data => {
					this.dispatch(
						Actions.setLogFile({
							result: data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
	/**
	 * ログファイルをダウンロード
	 * @param dispatch
	 * @param token
	 */
	public static createFetchExcelFileDownload(
		dispatch: Dispatch,
		token: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(orgId: string) {
				const params = {
					accessType: 10,
					orgID: orgId,
				};
				return this.read(
					'per_quickmode_SearchExcelFileBlockModel',
					params
				).then(data => {
					this.dispatch(
						Actions.setExcelFile({
							excelResult: data,
						})
					);
				});
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/QuickModeStudentAssignScenarioFactory.ts